import LazyLoad from "@/utils/AsyncRouteHelper";
import iBookRoutes from "./routes/iBook";

//const AppToolbar = () => import(/* webpackChunkName: "Vusenavs", webpackPreload: true */ "@/layouts/App/Toolbar_st");
//const AppFooter  = () => import(/* webpackChunkName: "Vusenavs", webpackPreload: true */ "@/layouts/App/Footer");

// ── define both toolbars once ──
const AppToolbar    = () => import(/* webpackChunkName: "toolbar"    */ "@/layouts/App/Toolbar");
const AppToolbar_st = () => import(/* webpackChunkName: "toolbar-st" */ "@/layouts/App/Toolbar_st");
const AppFooter     = () => import(/* webpackChunkName: "footer"     */ "@/layouts/App/Footer");

// ── /st path gets stepper toolbar, everything else gets standard toolbar ──
function resolveToolbar(path) {
  if (path === '/st') return AppToolbar_st;
  return AppToolbar;
}



const routes = iBookRoutes.map((route) => {
  const { params, defaultComponentPath, navs, unsignednavs, bossnavs } = route;
  const toolbar = resolveToolbar(params.path); // ← per-route toolbar

  const componentObj = navs ? {
      components: {
        default: LazyLoad(defaultComponentPath),
        header:  toolbar,
        footer:  AppFooter,
      },
    } : unsignednavs ? {
      components: {
        default: LazyLoad(defaultComponentPath),
        footer:  AppFooter,
      },
    } : bossnavs ? {
      components: {
        default: LazyLoad(defaultComponentPath),
        header:  toolbar,
        footer:  AppFooter,
      },
    } : {
      component: LazyLoad(defaultComponentPath),
    };

  return {
    ...params,
    ...componentObj,
  };
});

// ← removed { path: "/", redirect: "/ " } — space in URL is invalid
// ← the "/ " route in iBook.js handles the root path already
export default [...routes];

/*
import LazyLoad from "@/utils/AsyncRouteHelper";
import iBookRoutes from "./routes/iBook";

const AppToolbar = () =>  import(   "@/layouts/App/Toolbar" );
const AppFooter = () =>  import( "@/layouts/App/Footer" );

const AllRoutes = [ ...iBookRoutes];
const routes = AllRoutes.map((route) => {
const { params, defaultComponentPath, navs, unsignednavs, bossnavs } = route;
const componentObj = navs ? {
        components: {
          default: LazyLoad(defaultComponentPath),
          //sidebar: AppSidebar,
          header: AppToolbar,
          footer: AppFooter,
        },
      }
    : unsignednavs ?{
		components: {
			default: LazyLoad(defaultComponentPath),
			//sidebar: UnsignedSidebar,
			//header: UnsignedToolbar,
			footer: AppFooter,
        },
	}: bossnavs ?{
		components: {
			default: LazyLoad(defaultComponentPath),
			//sidebar: BossSidebar,
			header: AppToolbar,
			footer: AppFooter,
        },
  }:
	{
    component: LazyLoad(defaultComponentPath),
    };
  return {
    ...params,
    ...componentObj,
  };
});

export default [{ path: "/", redirect: "/ " }, ...routes];
*/
//export default [routes];
